export const jobPosts = {
  alerts: {
    errorApplied: 'Something went wrong while sending your response. Please try again later.',
    successCancelled: 'Your assignment has been cancelled and will no longer be shown.',
    successCreated: 'Your assignment has been created.',
    successFilled: 'Your assignment has been filled and will no longer be shown.',
    successUpdated: 'Your assignment has been updated.',
  },
  apply: {
    actions: {
      submit: 'Send',
    },
    motivation: {
      explanation: 'Write a personal response for your client here.',
      title: 'Your motivation',
    },
    profile: {
      contactDetails: 'Your contact details',
      explanation: 'We share the details below with your client. You can untick any information you’d rather not share.',
      fields: {
        address: 'Address',
        email: 'Email address',
        links: 'Links',
        phone: 'Phone number',
      },
      introductionText: 'Introduction',
      title: 'Your profile',
    },
    successDialog: {
      buttonText: 'Got it!',
      description:
        'Your response has been sent to the client. They’ll receive an email about it and will then (hopefully) contact you. So hang tight.',
      title: 'Response sent',
    },
    title: 'Contact',
  },
  breadcrumb: {
    bookmarked: 'Bookmarked assignments',
    create: 'Create assignment',
    overview: 'Assignments',
    own: 'My assignments',
  },
  card: {
    postedByCS: 'Curated by Creative Shelter',
    postedByFreelancer: 'Posted by a freelancer',
  },
  contextMenu: {
    actions: {
      cancelled: 'Cancel',
      edit: 'Edit',
      filled: 'Filled',
    },
    dialogs: {
      cancelled: {
        actions: {
          cancel: 'No, go back',
          confirm: 'Yes, I’m sure!',
        },
        description: 'Your assignment gets the status ‘cancelled’ and will no longer be shown. You can’t undo this change.',
        title: 'Are you sure?',
      },
      filled: {
        actions: {
          cancel: 'No, go back',
          confirm: 'Yes, I’m sure!',
        },
        description: 'Your assignment gets the status ‘filled’ and will no longer be shown. You can’t undo this change.',
        title: 'Are you sure?',
      },
    },
  },
  createEdit: {
    actions: {
      create: 'Create assignment',
    },
    blocker: 'Are you sure you want to leave this page? Your assignment has not been saved.',
    sections: {
      basic: {
        title: 'Basic information',
      },
      details: {
        title: 'Assignment details',
      },
      planning: {
        title: 'Planning',
      },
    },
    title: {
      create: 'New assignment',
      edit: 'Edit assignment',
    },
  },
  details: {
    actions: {
      alreadyApplied: 'Already contacted',
      apply: 'Contact client',
    },
    info: {
      alreadyApplied: {
        description: 'You contacted your client, now you just have to wait for a response.',
        title: 'Client contacted',
      },
      userHasCreated: {
        description: 'You can’t respond to it yourself, but you can edit it if you want.',
        title: 'You posted this assignment yourself',
      },
    },
  },
  fields: {
    activities: {
      label: 'Type of assignment',
      placeholder: 'Select',
    },
    closesAt: {
      label: 'Respond before',
    },
    createdAt: {
      label: 'Created on',
    },
    description: {
      label: 'Description',
    },
    endsAt: {
      label: 'End date',
    },
    experienceLevel: {
      label: 'Experience',
      options: {
        Junior: 'Junior',
        Medior: 'Intermediate',
        Senior: 'Senior',
      },
      placeholder: 'Select',
    },
    isPriceToBeDiscussed: {
      label: 'To be discussed',
    },
    locationType: {
      label: 'Workplace',
      options: {
        Hybrid: 'Hybrid',
        Onsite: 'On location',
        Remote: 'Remote',
      },
      placeholder: 'Select',
    },
    price: {
      label: 'Budget',
      placeholder: 'Budget',
    },
    priceUnit: {
      label: 'Unit',
      options: {
        Daily: 'Day',
        Fixed: 'Fixed fee',
        HalfDaily: 'Half day',
        Hourly: 'Hour',
        PricePerWord: 'Word',
      },
      placeholder: 'Unit per price',
    },
    region: {
      label: 'Assignment location',
      placeholder: 'Select',
    },
    startsAt: {
      label: 'Start date',
    },
    status: {
      options: {
        Cancelled: 'Cancelled',
        Filled: 'Filled',
        Open: 'Open',
      },
    },
    title: {
      label: 'Title',
      placeholder: 'Title',
    },
  },
  overview: {
    actions: {
      create: 'Create assignment',
    },
    bookmarked: {
      empty: 'You haven’t bookmarked any assignments yet.',
    },
    description: 'Find high-quality assignments from other freelancers and external clients here.',
    error: {
      title: 'Error loading the assignments.',
    },
    filters: {
      activities: 'Activities',
      locationType: 'Workplace',
      regions: 'Regions',
    },
    loading: 'Loading data…',
    own: {
      empty: 'You haven’t created any assignments yet.',
    },
    resetFilters: '(clear filters)',
    resultCount_one: '{{count}} result',
    resultCount_other: '{{count}} results',
    resultCount_zero: 'No match found based on your filters',
    title: 'Assignments',
  },
  specifications: {
    closesAt: 'Respond before',
    experienceLevel: 'Experience',
    location: 'Location',
    locationType: 'Workplace',
    period: 'Period',
    price: 'Budget',
  },
  tabs: {
    all: 'All assignments',
    bookmarked: 'Bookmarked assignments',
    own: 'My assignments',
  },
};
